import { blobResponseHandler, downloadBlob, providesList } from '@/shared/helpers/api';
import { baseApi } from '@/admin/baseApi';
import { t } from '@/core/localization';
import { addTimestampToFileName } from '@/core/utils/datetime';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { stockReceiptActions } from './stockReceipt.state';
// TODO: to delete all redundant comment later, during Stock Receipt refactoring
// TODO: later, during old sections removing refactoring. Extract to constants?
/** Count of rows that should be rendered inside Invoice table to prevent lagging. */
const maxInvoiceRowCount = 100;
// interface PlaceInStockMutationResult {
// 	success: boolean;
// 	error: string;
// }
const api = baseApi.enhanceEndpoints({ addTagTypes: ['Invoices', 'StockReceiptItems'] }).injectEndpoints({
    endpoints: (builder) => ({
        getStockInvoices: builder.query({
            query: (body) => ({
                // url: `stock/${getStockLocationId()}/receipt/invoices`,
                method: 'POST',
                url: 'stock/invoices',
                body,
            }),
            providesTags: (invoices) => providesList(invoices, 'Invoices', 'stockInvoiceId'),
            // This code is ok for old endpoint, it should be used.
            // /** Updates stock invoice's `receiptedQuantity` field on socket notification. */
            // onCacheEntryAdded: async (_, { updateCachedData, cacheDataLoaded, cacheEntryRemoved }) => {
            // 	const { addEventListener, events } = signalrHubConnector(SignalrConnectionHub.Stock);
            // 	try {
            // 		await cacheDataLoaded;
            // 		const listener: ConnectionHubListenerEvent<'Placement'> = (message) => {
            // 			updateCachedData((draft) => {
            // 				const invoiceIndex = draft.findIndex((invoice) => invoice.stockInvoiceId === message.stockInvoice.stockInvoiceId);
            // 				if (invoiceIndex === -1) return;
            // 				draft[invoiceIndex].receiptedQuantity = message.stockInvoice.receiptedQuantity;
            // 			});
            // 		};
            // 		addEventListener<SignalrConnectionHub.Stock>('Placement', listener);
            // 	} catch {
            // 		// no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
            // 		// in which case `cacheDataLoaded` will throw
            // 	}
            // 	await cacheEntryRemoved;
            // },
        }),
        // getStockReceiptItems: builder.query<StockReceiptItem[], GetStockReceiptItemsRequest>({
        getStockReceiptItems: builder.query({
            query: ({ stockInvoiceId, verification }) => ({
                url: 'stock/receiptItems',
                method: 'POST',
                // Different queries: for Verification tab - only `IsAccepted` and `IsBlocked` flags are valid; for Invoice
                // receiptItems - only stockInvoiceId.
                body: { ...(verification ? { IsAccepted: false, IsBlocked: false } : { stockInvoiceId }) },
            }),
            onQueryStarted: async ({ verification }, { dispatch, queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                    if (verification)
                        dispatch(stockReceiptActions.setVerificationItemCount(result.data.length));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stock.receipt.items.request.failed'), error }));
                }
            },
            providesTags: (receiptItems) => providesList(receiptItems, 'StockReceiptItems', 'stockReceiptItemId'),
            // /** Updates stockReceiptItem's `receiptedQuantity` field on socket notification. */
            // onCacheEntryAdded: async (_, { updateCachedData, cacheDataLoaded, cacheEntryRemoved }) => {
            // 	const { addEventListener, events } = signalrHubConnector(SignalrConnectionHub.Stock);
            // 	try {
            // 		await cacheDataLoaded;
            // 		const listener: ConnectionHubListenerEvent<'Placement'> = (message) => {
            // 			updateCachedData((draft) => {
            // 				const receiptItemIndex = draft.findIndex((item) => item.stockReceiptItemId === message.receiptItem.stockReceiptItemId);
            // 				if (receiptItemIndex === -1) return;
            // 				draft[receiptItemIndex].receiptedQuantity = message.receiptItem.receiptedQuantity;
            // 			});
            // 		};
            // 		addEventListener<SignalrConnectionHub.Stock>('Placement', listener);
            // 	} catch {
            // 		// no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
            // 		// in which case `cacheDataLoaded` will throw
            // 	}
            // 	await cacheEntryRemoved;
            // },
        }),
        // TODO: it is not used right now, it is for later when new backend in admin is finished.
        getStockReceiptItems_New: builder.query({
            // query: ({ invoiceId } = { invoiceId: undefined }) => ({
            query: (params) => ({
                method: 'GET',
                url: `stock/${'getStockLocationId()'}/receipt/items`,
                // ...(invoiceId && { params: { invoiceId } }),
                // ...(params && { params: { invoiceId: params.invoiceId } }),
                ...(params ? { params } : {}),
            }),
            // onQueryStarted: async ({ stockInvoiceId, verification }, { dispatch, queryFulfilled }) => {
            onQueryStarted: async ({ invoiceId } = { invoiceId: undefined }, { dispatch, queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                    if (!invoiceId)
                        dispatch(stockReceiptActions.setVerificationItemCount(result.data.receiptItems.length));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stock.receipt.items.request.failed'), error }));
                }
            },
            providesTags: (result) => providesList(result?.receiptItems, 'StockReceiptItems', 'stockReceiptItemId'),
            // /** Updates stockReceiptItem's `receiptedQuantity` field on socket notification. */
            // onCacheEntryAdded: async (_, { updateCachedData, cacheDataLoaded, cacheEntryRemoved }) => {
            // 	const { addEventListener, events } = signalrHubConnector(SignalrConnectionHub.Stock);
            // 	try {
            // 		await cacheDataLoaded;
            // 		const listener: ConnectionHubListenerEvent<'Placement'> = (message) => {
            // 			updateCachedData((draft) => {
            // 				const receiptItemIndex = draft.findIndex((item) => item.stockReceiptItemId === message.receiptItem.stockReceiptItemId);
            // 				if (receiptItemIndex === -1) return;
            // 				draft[receiptItemIndex].receiptedQuantity = message.receiptItem.receiptedQuantity;
            // 			});
            // 		};
            // 		addEventListener<SignalrConnectionHub.Stock>('Placement', listener);
            // 	} catch {
            // 		// no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
            // 		// in which case `cacheDataLoaded` will throw
            // 	}
            // 	await cacheEntryRemoved;
            // },
        }),
        // TODO: later. Duplicated from shared stock.shared.api. Btw it is OLD backend endpoint.
        // And check for IStock!
        getStockInfo: builder.query({
            query: (stockId) => {
                return {
                    method: 'GET',
                    url: `stock/getStock/${stockId}`,
                };
            },
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stock.info.request.failed'), error }));
                }
            },
        }),
        // // TODO: check if it is used
        // getStockCells: builder.query<{ cellId: number }, void>({
        // 	query: () => ({
        // 		method: 'GET',
        // 		url: 'stock/cells',
        // 	}),
        // }),
        // placeInStock: builder.mutation<PlaceInStockMutationResult, StockReceiptItemPlace>({
        // 	query: ({ stockReceiptItemId, ...body }) => ({
        // 		method: 'POST',
        // 		url: `stock/${getStockLocationId()}/receipt/${stockReceiptItemId}/place`,
        // 		body,
        // 	}),
        // 	invalidatesTags: (result, error, { stockReceiptItemId }) => (error ? [] : [{ type: 'StockReceiptItems', id: stockReceiptItemId }]),
        // }),
        // TODO: to delete later, this endpoint should only be used in Admin later.
        uploadInvoice: builder.mutation({
            query: (file) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    method: 'POST',
                    url: 'stockInvoiceParsing/upload',
                    body: formData,
                };
            },
            transformResponse: ({ cells, ...baseQueryReturnValue }) => {
                return {
                    ...baseQueryReturnValue,
                    cells: cells.slice(0, maxInvoiceRowCount),
                };
            },
        }),
        getParsedInvoiceSettings: builder.query({
            query: () => ({
                method: 'GET',
                url: 'stockInvoiceParsing/settings',
            }),
        }),
        editParsedInvoiceSettings: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: 'stockInvoiceParsing/settings',
                body,
            }),
        }),
        processInvoice: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: 'stockInvoiceParsing/process',
                body,
            }),
            invalidatesTags: (result, error) => (error ? [] : [{ type: 'Invoices', id: 'LIST' }]),
        }),
        uploadSurplusAndGetPreview: builder.mutation({
            query: (file) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    method: 'POST',
                    url: 'stock/surplus/preview ',
                    body: formData,
                };
            },
        }),
        findSurplusItemsPrices: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: 'stock/surplus/find-prices',
                body,
            }),
        }),
        exportSurplusItemsToExcel: builder.mutation({
            queryFn: async (body, api, extraOptions, baseQuery) => downloadBlob({
                queryResult: await baseQuery({
                    method: 'POST',
                    cache: 'no-cache',
                    url: 'stock/surplus/excel',
                    body,
                    responseHandler: blobResponseHandler,
                }),
                // TODO: (for claude) check if we can use filename returned by backend
                // TODO: check what file name to use (backend returns proper file name)
                fileName: `${t('upload.surplus.items.export.to.excel.file.name')} ${addTimestampToFileName()}.xlsx`,
            }),
        }),
        createSurplusReceiptTask: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: 'stock/surplus/receipt',
                body,
            }),
            invalidatesTags: (result, error) => (error ? [] : [{ type: 'Invoices', id: 'LIST' }]),
        }),
    }),
});
export const { useGetStockInvoicesQuery, useGetStockReceiptItemsQuery, useGetStockInfoQuery } = api;
export { api as stockReceiptApi };
